
import env from '~/libs/env'

const validatedZips = {}

async function isValidZip (zipId, $axios) {
  const { data } = await $axios.get(`${env('apiUrl')}/zipcode/${zipId}`)

  return data.data.exists
}

export function zipValidator($axios) {
  let active

  return function(value) {
    return new Promise(async (resolve) => {
      if (active) {
        return resolve(false)
      }
      active = true

      const matchedValue = String(value).match(/([0-9]){5}/)?.[0]
      if(!matchedValue) {
        active = false
        return resolve(false)
      }

      if(validatedZips.hasOwnProperty(matchedValue)) {
        active = false
        return resolve(validatedZips[matchedValue])
      }

      validatedZips[matchedValue] = await isValidZip(matchedValue, $axios)
      active = false
      return resolve(validatedZips[value])
    })
  }
}

export default {
  zipValidator
}
